"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const Chip_1 = __importDefault(require("@mui/material/Chip"));
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const common_buoy_icons_1 = require("@buoyhealth/common.buoy-icons");
const classnames_1 = __importDefault(require("classnames"));
const StyledChip = (0, styled_components_1.default)(Chip_1.default) `
  .MuiChip-label {
    ${common_buoy_theme_1.Body.primary.smaller}
    font-size: ${(props) => props.$fontSize ? `${props.$fontSize}px` : undefined};
    color: ${(props) => props.theme.palette.blue[70]};
    padding-left: ${(props) => (props.$hasIcon ? 0 : "8px")};
    padding-right: ${(props) => (props.$deletable ? 0 : "8px")};
    padding-top: 3px;
    padding-bottom: 3px;
  }

  &.MuiChip-outlined {
    .MuiChip-deleteIconSmall,
    .BuoyIcon-Container,
    .MuiChip-iconSmall {
      height: ${(props) => props.$fontSize ? `${props.$fontSize + 2}px` : "14px"};
      width: ${(props) => props.$fontSize ? `${props.$fontSize + 2}px` : "14px"};
      margin: 0 4px;
    }

    .BuoyIcon-Container svg {
      margin: 0;
      height: ${(props) => props.$fontSize ? `${props.$fontSize + 2}px` : "14px"};
      width: ${(props) => props.$fontSize ? `${props.$fontSize + 2}px` : "14px"};
    }
  }

  &.MuiChip-outlinedPrimary {
    border-color: ${(props) => props.theme.palette.blue[70]};
    /* height: 22px; */
    height: auto;

    &.MuiChip-clickable:hover {
      background-color: ${(props) => props.theme.palette.blue[0]};

      .MuiChip-deleteIcon circle {
        fill: ${(props) => props.theme.palette.blue[10]};
      }
    }

    &.MuiChip-clickable,
    &.MuiChip-deletable {
      .MuiChip-deleteIcon circle:hover {
        fill: ${(props) => props.theme.palette.blue[10]};
      }

      &:focus {
        background-color: ${(props) => props.theme.palette.common.white};
      }

      &.Mui-focusVisible {
        box-shadow: ${(props) => `0 0 10px 0 ${props.theme.palette.primary.main}, 0 0 5px 0 ${props.theme.palette.primary.main}}`};
      }
    }

    &.MuiChip-root.Mui-disabled {
      border-color: ${(props) => props.theme.palette.text.disabled};
      opacity: 1;

      .MuiChip-label {
        color: ${(props) => props.theme.palette.text.disabled};
      }

      svg {
        filter: grayscale(100%);
      }
    }

    &.selected {
      background-color: ${(props) => props.theme.palette.blue[70]};

      &.MuiChip-clickable {
        &:focus {
          background-color: ${(props) => props.theme.palette.blue[70]};
        }
        :hover {
          background-color: ${(props) => props.theme.palette.blue[90]};
        }
      }

      .MuiChip-label {
        color: ${(props) => props.theme.palette.common.white};
      }

      &.Mui-disabled {
        background-color: ${(props) => props.theme.palette.text.disabled};

        .MuiChip-label {
          color: ${(props) => props.theme.palette.common.white};
        }
      }
    }
  }
`;
/**
 * Chips act as tags to categorize care resource information.
 * For example; all virtual health care resources will have the tag virtual care.
 * Chips allow the users to understand which type of category a resource belongs to.
 *
 * **Principles**
 * *Compact* - Chips are compact components that represent discrete information.
 * *Relevant* - Chips should have a clear and helpful relationship to the content or task they represent.
 * *Focused* - Chips should make tasks easier to complete, or content easier to sort.
 */
const Chip = ({ disabled, fontSize = 12, label, Icon, iconProps, onDelete, onClick, selected, ...rest }) => ((0, jsx_runtime_1.jsx)(StyledChip, { "$deletable": !!onDelete, "$fontSize": fontSize, "$hasIcon": !!Icon, "$selected": selected, className: (0, classnames_1.default)({ selected }), color: "primary", deleteIcon: (0, jsx_runtime_1.jsx)(common_buoy_icons_1.ChipCloseIcon, { disabled: disabled }), disabled: disabled, icon: selected && !!Icon ? ((0, jsx_runtime_1.jsx)(common_buoy_icons_1.ChipCheckIcon, {})) : (Icon && (0, jsx_runtime_1.jsx)(Icon, { ...iconProps, size: fontSize + 2 })), label: label, onClick: onClick, onDelete: onDelete, size: "small", variant: "outlined", ...rest }));
exports.default = Chip;
//# sourceMappingURL=index.js.map